// Single source of truth for styling: the Microform iframes can't read our CSS,
// so the same values feed both the shadow DOM CSS variables and the Microform styles.
export const theme = {
  font: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontSize: '16px',
  lineHeight: '24px',
  text: '#1a1a1a',
  placeholder: '#999',
  border: '#ccc',
  focus: '#0070d2',
  error: '#c23934',
};

export const themeCssVars: Record<string, string> = {
  '--ax-font': theme.font,
  '--ax-font-size': theme.fontSize,
  '--ax-line-height': theme.lineHeight,
  '--ax-text': theme.text,
  '--ax-placeholder': theme.placeholder,
  '--ax-border': theme.border,
  '--ax-focus': theme.focus,
  '--ax-error': theme.error,
};

export const microformStyles = {
  input: {
    'font-family': theme.font,
    'font-size': theme.fontSize,
    'line-height': theme.lineHeight,
    color: theme.text,
  },
  '::placeholder': { color: theme.placeholder },
  invalid: { color: theme.error },
};
